import { getFullNameWithPreferredName } from 'utils/helpers'
import type { DocumentWithAttributes } from 'lib/models/document'
import { getActivityTimestamp } from 'components/activity-timestamp'

export const getUploadedByWithTime = (document: DocumentWithAttributes) => {
  let text = 'Uploaded on'
  if (document.attributes.uploadedByAdmin) {
    text = `Uploaded by ${document.attributes.uploadedByAdmin.name}`
  } else if (document.attributes.uploadedByAccount) {
    text = `Uploaded by ${getFullNameWithPreferredName(
      document.attributes.uploadedByAccount.contact
    )}`
  }
  return `${text} ${getActivityTimestamp(document.attributes.createdAt)}`
}

export const getSavedByWithTime = (document: DocumentWithAttributes) => {
  let text = 'Saved on'
  if (document.attributes.savedBy) {
    text = `Saved by ${document.attributes.savedBy.name}`
  }
  return `${text} ${getActivityTimestamp(document.attributes.savedAt)}`
}
